<template>
  <v-app-bar color="primary" elevation="0" app>
    <v-row>
      <v-col cols="4" class="d-flex align-center">
        <v-btn text class="mx-1">
          <div style="width: 90px;">
            <UCPALogo />
          </div>
        </v-btn>
        <v-chip class="mr-3 d-none d-sm-flex black--text" small>Recherche Produits</v-chip>
      </v-col>
      <v-col cols="4">
        <div style="width: 100%" class="d-flex justify-center">
          <v-responsive max-width="560">
            <v-text-field
              v-model="query"
              dark
              flat
              solo-inverted
              hide-details
              prepend-inner-icon="mdi-magnify"
              label="Recherche"
              transition="scale-transition"
            ></v-text-field>
          </v-responsive></div
      ></v-col>
      <v-col  cols="4" class="d-flex justify-end align-center">
        <v-select
          v-model="$store.state.activeBrand"
          @change="updateActiveBrand"
          style="max-width: 250px;"
          dark
          class="d-none d-sm-flex mr-6"
          :items="allowedBrands"
          hide-details
          item-text="label"
          item-value="value"
          outlined
          dense
      />
   
        <v-btn class="mr-4 white--text" outlined @click="goBackToIresa()">
          <v-icon>mdi-page-previous-outline</v-icon>
          <span class="ml-2 d-none d-sm-inline-block">Retour vers Iresa</span>
        </v-btn>

        <v-menu
          v-if="user"
          :close-on-content-click="false"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon small>
              <v-icon color="white" v-bind="attrs" v-on="on">mdi-account-circle</v-icon>
            </v-btn>
          </template>

          <v-card >
            <v-list>
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon>mdi-account-circle</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="d-block mr-4">
                  <v-list-item-title>{{user.name}}</v-list-item-title>
                  <v-list-item-subtitle>{{user.email}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="logout">Logout</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-col>
    </v-row>
  </v-app-bar>
</template>
<script>
const { VUE_APP_IRESA_URL } = process.env;
import UCPALogo from './UCPALogo'
import { getLogoutUrl } from '@/utils/auth';

export default {
  data: () => ({
    query: "",
    brands: [
        { label: 'UCPA', value: 'ucpa', resa_id: 1},
        // { label: 'TELLIGO', value: 'telligo' },
        { label: 'LA BALAGUERE', value: 'labalaguere', resa_id: 2}
    ],
    allowedBrands: [],
    brand: ''
  }),
  components: {
    UCPALogo
  },
  methods: {
    updateActiveBrand() {
      const active = this.brands.find(br => br.value === this.$store.state.activeBrand)
      this.$store.state.contextInfo.rese_id = active.resa_id
    },
    logout() {
      window.localStorage.clear();
      window.location.href = getLogoutUrl(window.location.origin, process.env.VUE_APP_SSO_CLIENT_ID, window.location.origin);
    },
    goBackToIresa() {
      // Go back to iResa Domain
      let url = VUE_APP_IRESA_URL.split('/');
      window.location.assign(`${url[0]}//${url[2]}/dossier/VenteRead.aspx?0=0`);
    }
  },
  computed: {
    user () {
      return this.$store.state.user || {};
    }
  },
  async mounted() {
    // Initialize the query property
    if(this.$store.state.query !== "*"){
      this.query = this.$store.state.query;
    }

    const userRoles = this.user.roles

    if(userRoles.includes('iresa_search')) this.allowedBrands.push({ label: 'UCPA', value: 'ucpa', resa_id: 1})
    if(userRoles.includes('iresa_search_labalaguere_producers') || userRoles.includes('iresa_search_labalaguere_telesales')) this.allowedBrands.push({ label: 'LA BALAGUERE', value: 'labalaguere', resa_id: 2 })
    if(userRoles.includes('admin')) this.allowedBrands = this.brands
    
    // this.$store.commit("setActiveBrand", this.allowedBrands[0].value)
    this.updateActiveBrand()
  },
  watch: {
    query (val) { // Reactive Search by query string
      if(val.trim() === ""){
        this.$store.commit('setQuery', "*") // Seach by everything
      } else if(val.trim().length > 2) { // Only search when 2/3 chars are writting to prevent a lot of requests
        this.$store.commit('setQuery', val) // Seach by string
      }
    },
  },
};
</script>